// @ts-nocheck
export function createTickCallback() {
  let lastSubLabel = null; // This variable is captured in the closure of the returned function.

  return function (val, index) {
    const date = new Date(val);

    const mainLabel = this.getLabelForValue(date).split(", ")[1]; // 'HH:mm'
    const subLabel = this.getLabelForValue(date).split(", ")[0]; // 'MMM dd'
    if (subLabel !== lastSubLabel) {
      // If it's different, update lastSubLabel and return both.
      lastSubLabel = subLabel;

      return `${subLabel}, ${mainLabel}`;
    }
  };
}

export const TIME_RANGES = [
  { value: '24', label: '24 Hours' },
  { value: '48', label: '48 Hours' },
  { value: '72', label: '72 Hours' },
  { value: '96', label: '96 Hours' },
  { value: '192', label: '192 Hours' },
  { value: 'full', label: 'Full Range' }
];

export function createMonthDayTickCallback() {
  let lastSubLabel = null;

  return function (val) {
    const date = new Date(val);
    const subLabel = this.getLabelForValue(date).split(", ")[0]; // 'MMM dd'
    if (subLabel !== lastSubLabel) {
      lastSubLabel = subLabel;
      return subLabel;
    }
  };
}

export const buildXAxisTicks = (callback, isMobile) => {
  const ticks = { callback };
  return isMobile
    ? {
        ...ticks,
        autoSkip: true,
        maxTicksLimit: 10,
        maxRotation: 0,
        minRotation: 0,
        align: "inner",
      }
    : ticks;
};

// A y tick with just enough decimals for the step between ticks, so a 0.5 step reads 4.5 instead of a second "5"; whole-number steps stay whole
export function formatYAxisTick(value, index, ticks) {
  if (value === null || value === undefined) return value;
  // The step is read between inner ticks: an explicit min or max can sit off the regular grid
  const step = ticks?.length > 2 ? Math.abs(ticks[2].value - ticks[1].value) : ticks?.length === 2 ? Math.abs(ticks[1].value - ticks[0].value) : 1;
  let decimals = 0;
  while (decimals < 3 && Math.abs(step * 10 ** decimals - Math.round(step * 10 ** decimals)) > 1e-6) decimals++;
  return Number(value).toFixed(decimals);
}

export const applyMobileTicks = (ticks, isMobile, mobileOverrides = {}) =>
  isMobile ? { ...ticks, ...mobileOverrides } : ticks;

// Ctrl on Windows/Linux, ⌘ (meta) on Mac — the wheel-zoom modifier key. Requiring
// a modifier means plain scroll still scrolls the page; only modifier+scroll zooms.
export const ZOOM_MODIFIER_KEY =
  typeof navigator !== 'undefined' &&
  /Mac|iPhone|iPad|iPod/.test(navigator.platform || navigator.userAgent || '')
    ? 'meta'
    : 'ctrl';

export const buildZoomOptions = ({ isMobile, minXValue, maxXValue, minYValue, maxYValue, currentViewRef, onZoomReset }) => {
  const options = {
  zoom: {
    wheel: {
      enabled: true,  // Zoom on Ctrl/⌘+scroll; plain scroll still scrolls the page
      modifierKey: ZOOM_MODIFIER_KEY,
    },
    drag: {
      enabled: !isMobile,  // Only allow drag-to-zoom on desktop
      backgroundColor: 'rgba(66, 165, 245, 0.1)',
      borderColor: 'rgba(66, 165, 245, 0.5)',
      borderWidth: 1,
      threshold: 5,
    },
    mode: "xy",
    pinch: {
      enabled: isMobile,
    },
    onZoomReset: onZoomReset,  // Callback when zoom is reset
  },
  limits: {
    x: {
      min: minXValue,
      max: maxXValue,
      minRange: 60 * 60 * 1000,  // Minimum 1 hour range
    },
    y: {
      min: minYValue || 'original',
      max: maxYValue || 'original',
    },
  },
  pan: {
    enabled: isMobile,  // Only enable pan on mobile to avoid conflict with drag on desktop
    mode: "xy",
    threshold: 10,
    onPanComplete: function (ctx) {
      if (!isMobile) return;

      const currentMin = ctx.chart.scales.x.min;
      const currentMax = ctx.chart.scales.x.max;

      const prevMin = currentViewRef.current.start.getTime();
      const prevMax = currentViewRef.current.end.getTime();

      const prevMid = (prevMin + prevMax) / 2;
      const currentMid = (currentMin + currentMax) / 2;

      const duration = prevMax - prevMin;
      const halfDuration = duration / 2;

      if (currentMid < prevMid) {
        const newMin = prevMin - halfDuration;
        const newMax = prevMax - halfDuration;
        ctx.chart.zoomScale("x", { min: newMin, max: newMax }, false);
      } else if (currentMid > prevMid) {
        const newMin = prevMin + halfDuration;
        const newMax = prevMax + halfDuration;
        ctx.chart.zoomScale("x", { min: newMin, max: newMax }, false);
      }

      ctx.chart.tooltip.setActiveElements([], {});

      currentViewRef.current = {
        start: new Date(ctx.chart.scales.x.min),
        end: new Date(ctx.chart.scales.x.max),
      };
    },
  },
};

  return options;
};
